/*================================================================
‘Copyright © 2020, Cheers Interactive Pvt Ltd.  All rights reserved.
	  File Description : Company Documents field validations
 --------------------------------------------------------------------------------- 
	Creation Details 
	Date Created				: 27/Jul/2020 
	Author						: Anand Kumar
================================================================ 
*/

import React, { useState, useEffect } from "react";
import { DropdownList } from "react-widgets";
import CKEditor5 from "../../../../components/ckEditor5";
import PropTypes from "prop-types";

const TextField = (props) => {
  const [value, setValue] = useState("");
  useEffect(() => {
    let name = props.properties.name;
    setValue(props.formik.values[name]);
  }, [props.formik.values, props.properties.name]);

  return (
    <>
      <input
        className="form-control"
        autoComplete="off"
        {...props.formik.getFieldProps(...props.properties.name)}
        value={value}
        {...props.properties}
      />
      <div className="text-danger" style={{ display: props.formik.touched[props.properties.name] === true ? "block" : "none" }} role="alert">
        <small>{props.formik.touched[props.properties.name] === true ? props.formik.errors[props.properties.name] || "" : ""}</small>
      </div>
    </>
  );
};
const TextFieldInputGroup = (props) => {
  const [value, setValue] = useState("");

  useEffect(() => {
    let name = props.properties.name;
    setValue(props.formik.values[name]);
  }, [props.formik.values, props.properties.name]);

  return (
    <input
      className="form-control"
      autoComplete="off"
      {...props.formik.getFieldProps(...props.properties.name)}
      value={value}
      {...props.properties}
    />
  );
};

const CkEditor = (props) => {
  const [content, setContent] = useState("");
  const onChange = (evt, editor) => {
    const newContent = editor.getData();
    setContent(newContent);
    let changedData = {};
    changedData[props.properties.name] = newContent;
    props.formik.setFieldValue(props.properties.name, newContent);
  };

  useEffect(() => {
    let name = props.properties.name;
    setContent(props.formik.values[name] ? props.formik.values[name] : props.defaultContent ? props.defaultContent : "");
  }, [props.formik.values, props.properties.name]);

  return (
    <>
      <CKEditor5 content={content} onChange={onChange} editorHeight={props?.properties?.config?.height || props?.height || "600px"} />
      <div className="text-danger" style={{ display: props.formik.touched[props.properties.name] === true ? "block" : "none" }} role="alert">
        <small>{props.formik.touched[props.properties.name] === true ? props.formik.errors[props.properties.name] || "" : ""}</small>
      </div>
    </>
  );
};
const Dropdown = (props) => {
  const [value, setValue] = useState("");
  const onChange = (val) => {
    setValue(val);
    props.formik.setFieldValue(props.properties.name, val);
  };

  useEffect(() => {
    let name = props.properties.name;
    setValue(props.formik.values[name]);
  }, [props.formik.values, props.properties.name]);

  return (
    <DropdownList
      data={[...props.valueArr]}
      dropUp
      formik={props.formik}
      onChange={onChange}
      {...props.properties}
      value={value ? value : props.properties.value}
    />
  );
} ;

const formikShape = PropTypes.shape({
  values: PropTypes.object,
  touched: PropTypes.object,
  errors: PropTypes.object,
  getFieldProps: PropTypes.func,
  setFieldValue: PropTypes.func,
});

CkEditor.propTypes = {
  properties: PropTypes.object,
  height: PropTypes.string,
  defaultContent: PropTypes.string,
  formik: formikShape
};

Dropdown.propTypes = {
  properties: PropTypes.object,
  valueArr: PropTypes.array,
  formik: formikShape
};

TextField.propTypes = {
  properties: PropTypes.object,
  formik: formikShape
};

TextFieldInputGroup.propTypes = {
  properties: PropTypes.object,
  formik: formikShape
};
export { TextField, Dropdown, CkEditor, TextFieldInputGroup };
